module.exports = __webpack_public_path__ + "img/icon.7eb36ccd.svg";